// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276,9 12,15 18,9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-details-container {
  min-height: 100vh;
  background: #f8fafc;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.account-details-content {
  display: flex;
  min-height: calc(100vh - 80px); /* Assuming header height is 80px */
}

.account-main-content {
  flex: 1 1;
  padding: 2rem;
  overflow-y: auto;
}

.account-form-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}

/* Page Header */
.page-header {
  margin-bottom: 3rem;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 0.5rem;
}

.page-description {
  font-size: 1.1rem;
  color: #718096;
  margin: 0;
}

/* Form Sections */
.form-sections {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.changes-indicator {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.changes-count {
  font-size: 0.9rem;
  color: #f56565;
  font-weight: 500;
}

.changed-indicator {
  color: #f56565;
  font-weight: bold;
  margin-left: 0.25rem;
}

/* Profile Section */
.profile-section {
  border-left: 4px solid #4299e1;
}

.profile-upload-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.profile-upload-area {
  flex-shrink: 0;
}

.profile-upload-label {
  display: block;
  width: 120px;
  height: 120px;
  border: 2px dashed #cbd5e0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.profile-upload-label:hover {
  border-color: #4299e1;
  background: #f7fafc;
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.profile-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #a0aec0;
  gap: 0.5rem;
}

.profile-placeholder span {
  font-size: 0.9rem;
  font-weight: 500;
}

.profile-input {
  display: none;
}

.profile-actions {
  flex: 1 1;
}

.upload-hint {
  color: #718096;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.photo-buttons {
  display: flex;
  gap: 1rem;
}

/* User Details Section */
.user-details-section {
  border-left: 4px solid #48bb78;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.form-input {
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}

.form-input:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.form-input.changed {
  border-color: #f56565;
  background: #fef5e7;
}

.form-input.readonly {
  background: #f7fafc;
  color: #718096;
  cursor: not-allowed;
}

.form-hint {
  font-size: 0.8rem;
  color: #a0aec0;
  margin-top: 0.25rem;
}

/* Password Section */
.password-section {
  border-left: 4px solid #ed8936;
}

.password-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper .form-input {
  flex: 1 1;
  padding-right: 3rem;
}

.password-toggle {
  position: absolute;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #a0aec0;
  transition: color 0.3s ease;
}

.password-toggle:hover {
  color: #4a5568;
}

/* Buttons */
.btn {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-decoration: none;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: #4299e1;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #3182ce;
}

.btn-secondary {
  background: #e2e8f0;
  color: #4a5568;
}

.btn-secondary:hover:not(:disabled) {
  background: #cbd5e0;
}

.btn-text {
  background: transparent;
  color: #4299e1;
  padding: 0.5rem;
}

.btn-text:hover {
  background: #f7fafc;
}

.form-actions {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  margin-top: 1rem;
}

/* Messages */
.form-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.form-message.error {
  background: #fed7d7;
  color: #c53030;
  border: 1px solid #feb2b2;
}

.form-message.success {
  background: #c6f6d5;
  color: #2f855a;
  border: 1px solid #9ae6b4;
}

.message-icon {
  font-size: 1.1rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .profile-upload-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .account-main-content {
    padding: 1rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .form-section {
    padding: 1.5rem;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .changes-indicator {
    align-self: stretch;
    justify-content: space-between;
  }

  .photo-buttons {
    flex-direction: column;
  }

  .password-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .form-sections {
    gap: 1rem;
  }

  .form-section {
    padding: 1rem;
  }

  .profile-upload-label {
    width: 100px;
    height: 100px;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }

  .form-actions {
    flex-direction: column;
  }
}

/* Loading Animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Focus States for Accessibility */
.btn:focus,
.form-input:focus,
.profile-upload-label:focus {
  outline: 2px solid #4299e1;
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .account-details-container {
    background: white;
  }

  .form-section {
    box-shadow: none;
    border: 1px solid #e2e8f0;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .btn,
  .profile-upload-area {
    display: none;
  }
}

/* Layout adjustments for sidebar */
.account-details-content {
  margin-top: 80px; /* Account for fixed header */
  margin-left: 0px; /* Account for sidebar */
  transition: margin-left 0.3s ease;
}

.account-main-content.sidebar-collapsed {
  margin-left: 80px;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .account-details-content {
    margin-left: 0;
  }

  .account-main-content.sidebar-collapsed {
    margin-left: 80px;
  }
}

@media (max-width: 768px) {
  .account-details-content {
    margin-left: 0;
  }

  .account-main-content.sidebar-collapsed {
    margin-left: 280px;
  }
}


/* Loading and error states */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.loading-container h3,
.error-container h3 {
  margin: 16px 0 8px 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
}

.loading-container p,
.error-container p {
  color: #6b7280;
  margin-bottom: 24px;
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 16px;
}

.account-retry-button {
  background: none;
  border: none;
  color: #3b82f6;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.875rem;
  margin-left: 8px;
  padding: 0;
}

.account-retry-button:hover {
  color: #2563eb;
  text-decoration: none;
}

/* Enhanced form styles for dropdown fields */
.form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;
}

.form-select:disabled {
  background-color: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-select.disabled {
  background-color: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-select option:disabled {
  color: #9ca3af;
}

/* Enhanced change tracking styles */
.changed-indicator {
  color: #3b82f6;
  font-weight: bold;
  margin-left: 4px;
}

.form-input.changed,
.form-select.changed {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.changes-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.875rem;
}

.changes-count {
  color: #3b82f6;
  font-weight: 500;
}

.btn.btn-text {
  background: none;
  border: none;
  color: #6b7280;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font-size: 0.875rem;
}

.btn.btn-text:hover {
  color: #374151;
}

/* Form grid responsive layout */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-group.full-width {
    grid-column: 1;
  }
}

/* Rest of existing styles... */
.account-details-container {
  min-height: 100vh;
  background-color: #f8fafc;
}

.account-details-content {
  display: flex;
  min-height: calc(100vh - 80px);
}

.account-main-content {
  flex: 1 1;
  padding: 32px;
  margin-left: 0px;
  transition: margin-left 0.3s ease;
}

.account-main-content.sidebar-collapsed {
  margin-left: 80px;
}

.account-form-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
}

.page-description {
  color: #6b7280;
  font-size: 1rem;
}

.form-sections {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.form-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
  font-size: 0.875rem;
}

.form-input {
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.form-input:disabled {
  background-color: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-input.readonly {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}

.form-hint {
  color: #6b7280;
  font-size: 0.75rem;
  margin-top: 4px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn.btn-primary {
  background-color: #3b82f6;
  color: white;
  border: 1px solid #3b82f6;
}

.btn.btn-primary:hover:not(:disabled) {
  background-color: #2563eb;
  border-color: #2563eb;
}

.btn.btn-primary:disabled {
  background-color: #9ca3af;
  border-color: #9ca3af;
  cursor: not-allowed;
}

.btn.btn-secondary {
  background-color: white;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn.btn-secondary:hover {
  background-color: #f9fafb;
}

.form-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-top: 16px;
  font-size: 0.875rem;
}

.form-message.error {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.form-message.success {
  background-color: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.message-icon {
  font-size: 1rem;
}

@media (max-width: 768px) {
  .account-main-content {
    margin-left: 0;
    padding: 16px;
  }

  .account-main-content.sidebar-collapsed {
    margin-left: 0;
  }

  .form-section {
    padding: 16px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .loading-container,
  .error-container {
    padding: 32px 16px;
  }
}
/* Password form specific styles */
.password-section {
  border: 1px solid #e5e7eb;
}

.section-description {
  color: #6b7280;
  font-size: 0.875rem;
  margin-bottom: 24px;
  line-height: 1.5;
}

.password-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  padding-right: 48px !important;
}

.password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-toggle:hover:not(:disabled) {
  color: #374151;
}

.password-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.password-toggle:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.password-requirements {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.password-requirements h4 {
  margin: 0 0 12px 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.password-requirements ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.password-requirements li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 0.875rem;
  color: #6b7280;
  position: relative;
}

.password-requirements li::before {
  content: "○";
  color: #d1d5db;
  font-weight: bold;
}

.password-requirements li.requirement-met {
  color: #16a34a;
}

.password-requirements li.requirement-met::before {
  content: "✓";
  color: #16a34a;
}

.security-tips {
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;
}

.security-tips h4 {
  margin: 0 0 12px 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e40af;
}

.security-tips ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.security-tips li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 0;
  font-size: 0.875rem;
  color: #1e40af;
}

.security-tips li::before {
  content: "💡";
  margin-top: 1px;
}

.required {
  color: #dc2626;
  margin-left: 2px;
}

.message-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

/* Loading and error states */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.loading-container h3,
.error-container h3 {
  margin: 16px 0 8px 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
}

.loading-container p,
.error-container p {
  color: #6b7280;
  margin-bottom: 24px;
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 16px;
}

.account-retry-button {
  background: none;
  border: none;
  color: #3b82f6;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.875rem;
  margin-left: 8px;
  padding: 0;
}

.account-retry-button:hover {
  color: #2563eb;
  text-decoration: none;
}

/* Enhanced form styles for dropdown fields */
.form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;
}

.form-select:disabled {
  background-color: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-select.disabled {
  background-color: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-select option:disabled {
  color: #9ca3af;
}

/* Enhanced change tracking styles */
.changed-indicator {
  color: #3b82f6;
  font-weight: bold;
  margin-left: 4px;
}

.form-input.changed,
.form-select.changed {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.changes-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.875rem;
}

.changes-count {
  color: #3b82f6;
  font-weight: 500;
}

.btn.btn-text {
  background: none;
  border: none;
  color: #6b7280;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font-size: 0.875rem;
}

.btn.btn-text:hover {
  color: #374151;
}

/* Form grid responsive layout */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

@media (max-width: 768px) {
  .form-grid,
  .password-grid {
    grid-template-columns: 1fr;
  }

  .form-group.full-width {
    grid-column: 1;
  }
}

/* Rest of existing styles... */
.account-details-container {
  min-height: 100vh;
  background-color: #f8fafc;
}

.account-details-content {
  display: flex;
  min-height: calc(100vh - 80px);
}

.account-main-content {
  flex: 1 1;
  padding: 32px;
  margin-left: 0px;
  transition: margin-left 0.3s ease;
}

.account-main-content.sidebar-collapsed {
  margin-left: 80px;
}

.account-form-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
}

.page-description {
  color: #6b7280;
  font-size: 1rem;
}

.form-sections {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.form-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
  font-size: 0.875rem;
}

.form-input {
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.form-input:disabled {
  background-color: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-input.readonly {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}

.form-hint {
  color: #6b7280;
  font-size: 0.75rem;
  margin-top: 4px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn.btn-primary {
  background-color: #3b82f6;
  color: white;
  border: 1px solid #3b82f6;
}

.btn.btn-primary:hover:not(:disabled) {
  background-color: #2563eb;
  border-color: #2563eb;
}

.btn.btn-primary:disabled {
  background-color: #9ca3af;
  border-color: #9ca3af;
  cursor: not-allowed;
}

.btn.btn-secondary {
  background-color: white;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn.btn-secondary:hover {
  background-color: #f9fafb;
}

.form-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-top: 16px;
  font-size: 0.875rem;
}

.form-message.error {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.form-message.success {
  background-color: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.message-icon {
  font-size: 1rem;
}

@media (max-width: 768px) {
  .account-main-content {
    margin-left: 0;
    padding: 16px;
  }

  .account-main-content.sidebar-collapsed {
    margin-left: 0;
  }

  .form-section {
    padding: 16px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .loading-container,
  .error-container {
    padding: 32px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AccountDetails/AccountDetails.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,mCAAmC;AACrE;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE,gBAAgB,EAAE,6BAA6B;EAC/C,gBAAgB,EAAE,wBAAwB;EAC1C,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,yDAA2R;EAC3R,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,kBAAkB;EACpB;AACF;AACA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,yDAA2R;EAC3R,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":[".account-details-container {\n  min-height: 100vh;\n  background: #f8fafc;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.account-details-content {\n  display: flex;\n  min-height: calc(100vh - 80px); /* Assuming header height is 80px */\n}\n\n.account-main-content {\n  flex: 1;\n  padding: 2rem;\n  overflow-y: auto;\n}\n\n.account-form-wrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Page Header */\n.page-header {\n  margin-bottom: 3rem;\n}\n\n.page-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 0.5rem;\n}\n\n.page-description {\n  font-size: 1.1rem;\n  color: #718096;\n  margin: 0;\n}\n\n/* Form Sections */\n.form-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.form-section {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.section-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0;\n}\n\n.changes-indicator {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.changes-count {\n  font-size: 0.9rem;\n  color: #f56565;\n  font-weight: 500;\n}\n\n.changed-indicator {\n  color: #f56565;\n  font-weight: bold;\n  margin-left: 0.25rem;\n}\n\n/* Profile Section */\n.profile-section {\n  border-left: 4px solid #4299e1;\n}\n\n.profile-upload-container {\n  display: flex;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.profile-upload-area {\n  flex-shrink: 0;\n}\n\n.profile-upload-label {\n  display: block;\n  width: 120px;\n  height: 120px;\n  border: 2px dashed #cbd5e0;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.profile-upload-label:hover {\n  border-color: #4299e1;\n  background: #f7fafc;\n}\n\n.profile-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.profile-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #a0aec0;\n  gap: 0.5rem;\n}\n\n.profile-placeholder span {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.profile-input {\n  display: none;\n}\n\n.profile-actions {\n  flex: 1;\n}\n\n.upload-hint {\n  color: #718096;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.photo-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n/* User Details Section */\n.user-details-section {\n  border-left: 4px solid #48bb78;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #4a5568;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n}\n\n.form-input {\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.form-input.changed {\n  border-color: #f56565;\n  background: #fef5e7;\n}\n\n.form-input.readonly {\n  background: #f7fafc;\n  color: #718096;\n  cursor: not-allowed;\n}\n\n.form-hint {\n  font-size: 0.8rem;\n  color: #a0aec0;\n  margin-top: 0.25rem;\n}\n\n/* Password Section */\n.password-section {\n  border-left: 4px solid #ed8936;\n}\n\n.password-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper .form-input {\n  flex: 1;\n  padding-right: 3rem;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  color: #a0aec0;\n  transition: color 0.3s ease;\n}\n\n.password-toggle:hover {\n  color: #4a5568;\n}\n\n/* Buttons */\n.btn {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  text-decoration: none;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: #4299e1;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #3182ce;\n}\n\n.btn-secondary {\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #cbd5e0;\n}\n\n.btn-text {\n  background: transparent;\n  color: #4299e1;\n  padding: 0.5rem;\n}\n\n.btn-text:hover {\n  background: #f7fafc;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n/* Messages */\n.form-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-top: 1rem;\n  font-size: 0.9rem;\n}\n\n.form-message.error {\n  background: #fed7d7;\n  color: #c53030;\n  border: 1px solid #feb2b2;\n}\n\n.form-message.success {\n  background: #c6f6d5;\n  color: #2f855a;\n  border: 1px solid #9ae6b4;\n}\n\n.message-icon {\n  font-size: 1.1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .profile-upload-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .account-main-content {\n    padding: 1rem;\n  }\n\n  .page-title {\n    font-size: 2rem;\n  }\n\n  .form-section {\n    padding: 1.5rem;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .changes-indicator {\n    align-self: stretch;\n    justify-content: space-between;\n  }\n\n  .photo-buttons {\n    flex-direction: column;\n  }\n\n  .password-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .form-sections {\n    gap: 1rem;\n  }\n\n  .form-section {\n    padding: 1rem;\n  }\n\n  .profile-upload-label {\n    width: 100px;\n    height: 100px;\n  }\n\n  .btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n}\n\n/* Loading Animation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Focus States for Accessibility */\n.btn:focus,\n.form-input:focus,\n.profile-upload-label:focus {\n  outline: 2px solid #4299e1;\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .account-details-container {\n    background: white;\n  }\n\n  .form-section {\n    box-shadow: none;\n    border: 1px solid #e2e8f0;\n    break-inside: avoid;\n  }\n\n  .btn,\n  .profile-upload-area {\n    display: none;\n  }\n}\n\n/* Layout adjustments for sidebar */\n.account-details-content {\n  margin-top: 80px; /* Account for fixed header */\n  margin-left: 0px; /* Account for sidebar */\n  transition: margin-left 0.3s ease;\n}\n\n.account-main-content.sidebar-collapsed {\n  margin-left: 80px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .account-details-content {\n    margin-left: 0;\n  }\n\n  .account-main-content.sidebar-collapsed {\n    margin-left: 80px;\n  }\n}\n\n@media (max-width: 768px) {\n  .account-details-content {\n    margin-left: 0;\n  }\n\n  .account-main-content.sidebar-collapsed {\n    margin-left: 280px;\n  }\n}\n\n\n/* Loading and error states */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.loading-container h3,\n.error-container h3 {\n  margin: 16px 0 8px 0;\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.loading-container p,\n.error-container p {\n  color: #6b7280;\n  margin-bottom: 24px;\n}\n\n.error-icon {\n  font-size: 3rem;\n  margin-bottom: 16px;\n}\n\n.account-retry-button {\n  background: none;\n  border: none;\n  color: #3b82f6;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.875rem;\n  margin-left: 8px;\n  padding: 0;\n}\n\n.account-retry-button:hover {\n  color: #2563eb;\n  text-decoration: none;\n}\n\n/* Enhanced form styles for dropdown fields */\n.form-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n.form-select:disabled {\n  background-color: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-select.disabled {\n  background-color: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-select option:disabled {\n  color: #9ca3af;\n}\n\n/* Enhanced change tracking styles */\n.changed-indicator {\n  color: #3b82f6;\n  font-weight: bold;\n  margin-left: 4px;\n}\n\n.form-input.changed,\n.form-select.changed {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n.changes-indicator {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 0.875rem;\n}\n\n.changes-count {\n  color: #3b82f6;\n  font-weight: 500;\n}\n\n.btn.btn-text {\n  background: none;\n  border: none;\n  color: #6b7280;\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.875rem;\n}\n\n.btn.btn-text:hover {\n  color: #374151;\n}\n\n/* Form grid responsive layout */\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-group.full-width {\n    grid-column: 1;\n  }\n}\n\n/* Rest of existing styles... */\n.account-details-container {\n  min-height: 100vh;\n  background-color: #f8fafc;\n}\n\n.account-details-content {\n  display: flex;\n  min-height: calc(100vh - 80px);\n}\n\n.account-main-content {\n  flex: 1;\n  padding: 32px;\n  margin-left: 0px;\n  transition: margin-left 0.3s ease;\n}\n\n.account-main-content.sidebar-collapsed {\n  margin-left: 80px;\n}\n\n.account-form-wrapper {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 32px;\n}\n\n.page-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.page-description {\n  color: #6b7280;\n  font-size: 1rem;\n}\n\n.form-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.form-section {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.section-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-label {\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 6px;\n  font-size: 0.875rem;\n}\n\n.form-input {\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n.form-input:disabled {\n  background-color: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-input.readonly {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.form-hint {\n  color: #6b7280;\n  font-size: 0.75rem;\n  margin-top: 4px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn.btn-primary {\n  background-color: #3b82f6;\n  color: white;\n  border: 1px solid #3b82f6;\n}\n\n.btn.btn-primary:hover:not(:disabled) {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.btn.btn-primary:disabled {\n  background-color: #9ca3af;\n  border-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.btn.btn-secondary {\n  background-color: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.btn.btn-secondary:hover {\n  background-color: #f9fafb;\n}\n\n.form-message {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-top: 16px;\n  font-size: 0.875rem;\n}\n\n.form-message.error {\n  background-color: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.form-message.success {\n  background-color: #f0fdf4;\n  color: #16a34a;\n  border: 1px solid #bbf7d0;\n}\n\n.message-icon {\n  font-size: 1rem;\n}\n\n@media (max-width: 768px) {\n  .account-main-content {\n    margin-left: 0;\n    padding: 16px;\n  }\n\n  .account-main-content.sidebar-collapsed {\n    margin-left: 0;\n  }\n\n  .form-section {\n    padding: 16px;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .loading-container,\n  .error-container {\n    padding: 32px 16px;\n  }\n}\n/* Password form specific styles */\n.password-section {\n  border: 1px solid #e5e7eb;\n}\n\n.section-description {\n  color: #6b7280;\n  font-size: 0.875rem;\n  margin-bottom: 24px;\n  line-height: 1.5;\n}\n\n.password-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input {\n  padding-right: 48px !important;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 4px;\n  border-radius: 4px;\n  transition: color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.password-toggle:hover:not(:disabled) {\n  color: #374151;\n}\n\n.password-toggle:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.password-toggle:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n.password-requirements {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.password-requirements h4 {\n  margin: 0 0 12px 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.password-requirements ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.password-requirements li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n  position: relative;\n}\n\n.password-requirements li::before {\n  content: \"○\";\n  color: #d1d5db;\n  font-weight: bold;\n}\n\n.password-requirements li.requirement-met {\n  color: #16a34a;\n}\n\n.password-requirements li.requirement-met::before {\n  content: \"✓\";\n  color: #16a34a;\n}\n\n.security-tips {\n  background-color: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 24px;\n}\n\n.security-tips h4 {\n  margin: 0 0 12px 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #1e40af;\n}\n\n.security-tips ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.security-tips li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 4px 0;\n  font-size: 0.875rem;\n  color: #1e40af;\n}\n\n.security-tips li::before {\n  content: \"💡\";\n  margin-top: 1px;\n}\n\n.required {\n  color: #dc2626;\n  margin-left: 2px;\n}\n\n.message-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n/* Loading and error states */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.loading-container h3,\n.error-container h3 {\n  margin: 16px 0 8px 0;\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.loading-container p,\n.error-container p {\n  color: #6b7280;\n  margin-bottom: 24px;\n}\n\n.error-icon {\n  font-size: 3rem;\n  margin-bottom: 16px;\n}\n\n.account-retry-button {\n  background: none;\n  border: none;\n  color: #3b82f6;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.875rem;\n  margin-left: 8px;\n  padding: 0;\n}\n\n.account-retry-button:hover {\n  color: #2563eb;\n  text-decoration: none;\n}\n\n/* Enhanced form styles for dropdown fields */\n.form-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n.form-select:disabled {\n  background-color: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-select.disabled {\n  background-color: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-select option:disabled {\n  color: #9ca3af;\n}\n\n/* Enhanced change tracking styles */\n.changed-indicator {\n  color: #3b82f6;\n  font-weight: bold;\n  margin-left: 4px;\n}\n\n.form-input.changed,\n.form-select.changed {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n.changes-indicator {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 0.875rem;\n}\n\n.changes-count {\n  color: #3b82f6;\n  font-weight: 500;\n}\n\n.btn.btn-text {\n  background: none;\n  border: none;\n  color: #6b7280;\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.875rem;\n}\n\n.btn.btn-text:hover {\n  color: #374151;\n}\n\n/* Form grid responsive layout */\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 768px) {\n  .form-grid,\n  .password-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-group.full-width {\n    grid-column: 1;\n  }\n}\n\n/* Rest of existing styles... */\n.account-details-container {\n  min-height: 100vh;\n  background-color: #f8fafc;\n}\n\n.account-details-content {\n  display: flex;\n  min-height: calc(100vh - 80px);\n}\n\n.account-main-content {\n  flex: 1;\n  padding: 32px;\n  margin-left: 0px;\n  transition: margin-left 0.3s ease;\n}\n\n.account-main-content.sidebar-collapsed {\n  margin-left: 80px;\n}\n\n.account-form-wrapper {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 32px;\n}\n\n.page-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.page-description {\n  color: #6b7280;\n  font-size: 1rem;\n}\n\n.form-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.form-section {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.section-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-label {\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 6px;\n  font-size: 0.875rem;\n}\n\n.form-input {\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n.form-input:disabled {\n  background-color: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.form-input.readonly {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.form-hint {\n  color: #6b7280;\n  font-size: 0.75rem;\n  margin-top: 4px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn.btn-primary {\n  background-color: #3b82f6;\n  color: white;\n  border: 1px solid #3b82f6;\n}\n\n.btn.btn-primary:hover:not(:disabled) {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.btn.btn-primary:disabled {\n  background-color: #9ca3af;\n  border-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.btn.btn-secondary {\n  background-color: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.btn.btn-secondary:hover {\n  background-color: #f9fafb;\n}\n\n.form-message {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-top: 16px;\n  font-size: 0.875rem;\n}\n\n.form-message.error {\n  background-color: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.form-message.success {\n  background-color: #f0fdf4;\n  color: #16a34a;\n  border: 1px solid #bbf7d0;\n}\n\n.message-icon {\n  font-size: 1rem;\n}\n\n@media (max-width: 768px) {\n  .account-main-content {\n    margin-left: 0;\n    padding: 16px;\n  }\n\n  .account-main-content.sidebar-collapsed {\n    margin-left: 0;\n  }\n\n  .form-section {\n    padding: 16px;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .loading-container,\n  .error-container {\n    padding: 32px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
